import { graphql } from "../../gql";
import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import {
  ManualPlanBonusInput,
  UnlimitedLessonPerWeekEnabledInput,
  UserClassRoomPlanWarrantyConfigInputDto,
} from "../../gql/graphql.ts";

const UpdateUserClassRoomPlanMutation = graphql(`
  mutation updateUserClassRoomPlan(
    $planToRecoverId: String
    $planId: String!
    $warrantyConfig: UserClassRoomPlanWarrantyConfigInputDto
    $startedAtWeekUtc: String
    $endedAtWeekUtc: String
    $lessonsPerWeek: Int
    $bonuses: [ManualPlanBonusInput!]
    $unlimitedLessonPerWeek: UnlimitedLessonPerWeekEnabledInput
  ) {
    updateUserClassRoomPlan(
      planToRecoverId: $planToRecoverId
      planId: $planId
      warrantyConfig: $warrantyConfig
      startedAtWeekUtc: $startedAtWeekUtc
      endedAtWeekUtc: $endedAtWeekUtc
      lessonsPerWeek: $lessonsPerWeek
      bonuses: $bonuses
      unlimitedLessonPerWeek: $unlimitedLessonPerWeek
    ) {
      ...ClassRoomPlanFragment
    }
  }
`);
export function useUpdateUserClassRoomPlan() {
  const [updateUserClassRoomPlanMutation, { loading }] = useMutation(
    UpdateUserClassRoomPlanMutation,
  );

  const updateUserClassRoomPlan = useCallback(
    async (variables: {
      planToRecoverId?: string;
      planId: string;
      warrantyConfig?: UserClassRoomPlanWarrantyConfigInputDto;
      startedAtWeekUtc?: string;
      endedAtWeekUtc?: string;
      lessonsPerWeek?: number;
      bonuses?: ManualPlanBonusInput[];
      unlimitedLessonPerWeek?: UnlimitedLessonPerWeekEnabledInput;
    }) => {
      await updateUserClassRoomPlanMutation({
        variables,
      });
    },
    [updateUserClassRoomPlanMutation],
  );

  return {
    updateUserClassRoomPlan,
    loading,
  };
}
